<template>
  <v-container
    class="bg bg--gray"
    fill-height
    fluid
  >
    <LoginBox>
      <LoginForm
        v-if="loginContainer"
        @toggleContainer="toggleContainer"
      />

      <Success v-if="successContainer" />
    </LoginBox>
  </v-container>
</template>

<script>
import LoginForm from 'components/pages/SAPConcurIntegration/LoginForm'
import Success from 'components/pages/SAPConcurIntegration/Success'

export default {
  name: 'SAPConcurIntegrationPage',
  components: {
    LoginForm,
    Success
  },
  data () {
    return {
      loginContainer: true,
      successContainer: false
    }
  },
  methods: {
    toggleContainer () {
      this.loginContainer = !this.loginContainer
      this.successContainer = !this.successContainer
    }
  }
}
</script>
